export default __webpack_public_path__ + "static/media/beauty.3ef9462e.svg";